import { render, staticRenderFns } from "./navigationContent.vue?vue&type=template&id=466f853e"
import script from "./navigationContent.vue?vue&type=script&lang=js"
export * from "./navigationContent.vue?vue&type=script&lang=js"
import style0 from "./navigationContent.vue?vue&type=style&index=0&id=466f853e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/app/components/img.vue').default,Img: require('/app/components/img.vue').default})
